import {
  Default_getInstance2tu01uy631lll as Default_getInstance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isNumberiramasdbon0i as isNumber,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  Unit_instanceat14thlj150z as Unit_instance,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  to2cs3ny02qtbcb as to,
  printStackTrace18lnx7a39cni as printStackTrace,
  lazy2hsh8ze7j6ikd as lazy,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_Deflate2a0lyute7oxjd as get_Deflate,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-compression-root-korlibs-compression.mjs';
import { getS32LE1pxm9wohin3g8 as getS32LE } from './korlibs-memory-root-korlibs-memory.mjs';
import { jsObjectr1r5ao37ef4f as jsObject } from './korlibs-platform-root-korlibs-platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class IWASMLib {}
function readBytes(pos, size) {
  throw NotImplementedError.nd();
}
function writeBytes(pos, data) {
  throw NotImplementedError.nd();
}
function invokeFunc(name, params) {
  throw NotImplementedError.nd();
}
function invokeFuncInt(name, params) {
  var tmp = this.k3t(name, params.slice());
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : numberToInt(tmp0_safe_receiver);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function invokeFuncUnit(name, params) {
  this.k3t(name, params.slice());
}
function readInts(pos, size) {
  var bytes = this.i3t(pos, imul(size, 4));
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = getS32LE(bytes, imul(tmp_1, 4));
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function allocBytes(size) {
  return this.l3t('malloc', [size]);
}
function allocBytes_0(bytes) {
  // Inline function 'kotlin.also' call
  var this_0 = this.o3t(bytes.length);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.wasm.IWASMLib.allocBytes.<anonymous>' call
  this.j3t(this_0, bytes);
  return this_0;
}
function allocInts(size) {
  return this.o3t(imul(size, 4));
}
function freeBytes(ptrs) {
  var inductionVariable = 0;
  var last = ptrs.length;
  while (inductionVariable < last) {
    var ptr = ptrs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    this.k3t('free', [ptr]);
  }
}
class WASMLib {
  constructor(content) {
    this.h3t_1 = new JSWASMLib(content);
  }
  i3t(pos, size) {
    return this.h3t_1.i3t(pos, size);
  }
  j3t(pos, data) {
    this.h3t_1.j3t(pos, data);
  }
  k3t(name, params) {
    return this.h3t_1.k3t(name, params);
  }
  l3t(name, params) {
    return this.h3t_1.l3t(name, params);
  }
  m3t(name, params) {
    this.h3t_1.m3t(name, params);
  }
  n3t(pos, size) {
    return this.h3t_1.n3t(pos, size);
  }
  o3t(size) {
    return this.h3t_1.o3t(size);
  }
  p3t(bytes) {
    return this.h3t_1.p3t(bytes);
  }
  q3t(size) {
    return this.h3t_1.q3t(size);
  }
  r3t(ptrs) {
    this.h3t_1.r3t(ptrs);
  }
  y5() {
    this.h3t_1.y5();
  }
}
class Base64DeflateWASMLib extends WASMLib {
  constructor(content) {
    super(uncompress(Default_getInstance().sn(content), get_Deflate()));
  }
}
class BaseWASMLib {
  constructor(content) {
    this.t3t_1 = content;
    this.u3t_1 = null;
  }
  s3t() {
    return this.t3t_1;
  }
  y5() {
  }
}
class JSWASMLib extends BaseWASMLib {
  constructor(content) {
    super(content);
    this.x3t_1 = null;
    var tmp = this;
    tmp.y3t_1 = lazy(JSWASMLib$mem$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.z3t_1 = lazy(JSWASMLib$u8$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.a3u_1 = lazy(JSWASMLib$dataView$delegate$lambda(this));
  }
  i3t(pos, size) {
    var out = new Int8Array(size);
    var u8 = _get_u8__ndcayw(this);
    var inductionVariable = 0;
    var last = out.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        out[n] = u8[pos + n | 0];
      }
       while (inductionVariable <= last);
    return out;
  }
  j3t(pos, data) {
    var inductionVariable = 0;
    var last = data.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        _get_u8__ndcayw(this)[pos + n | 0] = data[n];
      }
       while (inductionVariable <= last);
  }
  k3t(name, params) {
    var tmp0_elvis_lhs = _get_wasmExports__dbcjyi(this)[name];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Can't find export '" + name + "'";
      throw IllegalStateException.s4(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var export_0 = tmp;
    return export_0.apply(_get_wasmExports__dbcjyi(this), params);
  }
  y5() {
    super.y5();
  }
}
//endregion
function _get_wasmExports__dbcjyi($this) {
  if ($this.x3t_1 == null) {
    var tmp = $this;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    try {
      var module_0 = new WebAssembly.Module(ensureNotNull($this.s3t()));
      var dummyFunc = JSWASMLib$_get_wasmExports_$lambda_zfsn0h;
      var imports = jsObject([to('env', jsObject([to('abort', dummyFunc), to('emscripten_notify_memory_growth', dummyFunc)])), to('wasi_snapshot_preview1', jsObject([to('proc_exit', dummyFunc), to('fd_close', dummyFunc), to('fd_write', dummyFunc), to('fd_seek', dummyFunc)]))]);
      tmp_0 = (new WebAssembly.Instance(module_0, imports)).exports;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.wasm.JSWASMLib.<get-wasmExports>.<anonymous>' call
    tmp.x3t_1 = tmp_0;
  }
  return $this.x3t_1;
}
function _get_mem__e6cqxo($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.y3t_1;
  mem$factory();
  return this_0.o1();
}
function _get_u8__ndcayw($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.z3t_1;
  u8$factory();
  return this_0.o1();
}
function JSWASMLib$_get_wasmExports_$lambda_zfsn0h() {
  console.log('proc_exit', arguments);
  return Unit_instance;
}
function JSWASMLib$mem$delegate$lambda(this$0) {
  return function () {
    return _get_wasmExports__dbcjyi(this$0).memory.buffer;
  };
}
function JSWASMLib$u8$delegate$lambda(this$0) {
  return function () {
    return new Uint8Array(_get_mem__e6cqxo(this$0));
  };
}
function JSWASMLib$dataView$delegate$lambda(this$0) {
  return function () {
    return new DataView(_get_mem__e6cqxo(this$0));
  };
}
function mem$factory() {
  return getPropertyCallableRef('mem', 1, KProperty1, function (receiver) {
    return _get_mem__e6cqxo(receiver);
  }, null);
}
function u8$factory() {
  return getPropertyCallableRef('u8', 1, KProperty1, function (receiver) {
    return _get_u8__ndcayw(receiver);
  }, null);
}
//region block: post-declaration
initMetadataForInterface(IWASMLib, 'IWASMLib', VOID, VOID, [AutoCloseable]);
initMetadataForClass(WASMLib, 'WASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(Base64DeflateWASMLib, 'Base64DeflateWASMLib');
protoOf(BaseWASMLib).i3t = readBytes;
protoOf(BaseWASMLib).j3t = writeBytes;
protoOf(BaseWASMLib).k3t = invokeFunc;
protoOf(BaseWASMLib).l3t = invokeFuncInt;
protoOf(BaseWASMLib).m3t = invokeFuncUnit;
protoOf(BaseWASMLib).n3t = readInts;
protoOf(BaseWASMLib).o3t = allocBytes;
protoOf(BaseWASMLib).p3t = allocBytes_0;
protoOf(BaseWASMLib).q3t = allocInts;
protoOf(BaseWASMLib).r3t = freeBytes;
initMetadataForClass(BaseWASMLib, 'BaseWASMLib', VOID, VOID, [IWASMLib]);
initMetadataForClass(JSWASMLib, 'JSWASMLib', VOID, VOID, [IWASMLib, BaseWASMLib]);
//endregion
//region block: exports
export {
  Base64DeflateWASMLib as Base64DeflateWASMLib1nkue0zm1qc0o,
};
//endregion
